<template>
  <div class="wrapper main-container future-commission-wrap">
    <div class="title">
      <h1>{{ formData.name }}</h1>
      <Button @click="back()" type="primary" ghost>返回</Button>
    </div>
    <div class="header">
      <span>产品编码： {{ formData.productCode || '-' }}</span>
      <span>保司：{{ formData.companyName || '-' }}</span>
      <span v-if="$units.superviseShowVal() && showSupplier">供应商：{{ formData.supplierName || '-' }}</span>
    </div>
    <div class="date-wrap">
      有效期：{{ filter.filterTime(formData.versionStartTime, 'YYYY-MM-DD HH:mm:ss') || '-' }} 至
      {{ filter.filterTime(formData.versionEndTime, 'YYYY-MM-DD HH:mm:ss') || '-' }}
    </div>
    <commissionDetail ref="commissionDetailRef"></commissionDetail>
  </div>
</template>
  
  <script>
import filter from '@/api/filter';
import { common } from '@/api/mixins';
import commissionDetail from './components/commissionDetail';
export default {
  components: { commissionDetail },
  mixins: [common],
  data() {
    return {
      filter,
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      formData: {
        productId: '',
        productCode: '',
        productCategory: '',
        versionNo: '',
        name: '',
        versionEndTime: '',
        versionStartTime: '',
        companyName: '',
        supplierName: '',
        versionType: ''
      }
    };
  },
  computed:{
    showSupplier(){
      let urlType = this.$route.query.urlType;
      if(!urlType){
        return true
      }else if(urlType == "groupProduct"){
        return this.$units.pointAction('pro_8_2')
      }else if(urlType == "productResource"){
        return this.$units.pointAction('pro_1_6')
      }
      return true
    }
  },
  mounted() {
    this.formData.versionNo = this.$route.query.versionNo;
    this.formData.productCode = this.$route.query.productCode;
    this.formData.productCategory = this.$route.query.productCategory;
    this.formData.productId = this.$route.query.productId;
    this.formData.versionEndTime = this.$route.query.versionEndTime;
    this.formData.versionType = this.$route.query.versionType;
    this.formData.name = this.$route.query.name;
    this.formData.versionStartTime = this.$route.query.versionStartTime;
    this.$refs.commissionDetailRef.init(JSON.parse(JSON.stringify(this.formData)));
    this.querySupplyInfos();
  },
  methods: {
    querySupplyInfos() {
      this.$http({
        url: '/buz/upcommission/querySupplyInfos',
        type: 'GET',
        data: {
          productCode: this.formData.productCode
        }
      }).then(res => {
        console.log(res.data);
        this.formData.companyName = res.data.companyName;
        this.formData.supplierName = res.data.supplierName;
      });
    }
  }
};
</script>
  <style lang="scss" scoped>
.future-commission-wrap {
  .title {
    margin-bottom: 15px;
    line-height: 1.5;
    height: unset;
    position: relative;
    h1 {
      font-size: 20px;
      color: #3c464f;
      font-weight: bold;
    }
    .ivu-btn {
      position: absolute;
      right: 10px;
      top: 0;
    }
  }
  .header {
    font-size: 14px;
    color: #333;
    margin-bottom: 36px;
    padding-right: 70px;
    position: relative;
    span {
      margin-right: 50px;
    }
    .ivu-btn {
      position: absolute;
      right: 0;
    }
  }
  .date-wrap {
    margin-bottom: 10px;
  }
  .table-wrap {
    padding-bottom: 20px;
    background-color: #fff;
    border-right: 0;
    border-bottom: 0;
    color: #3c464f;
    font-size: 13px;
    overflow: auto;
    max-height: calc(100vh - 140px);
    display: flex;
    flex-wrap: wrap;
    max-width: calc(100vw - 50px);
    width: min-content;
    .left-1 {
      z-index: 5;
      position: sticky;
      flex: 0 0 260px;
      left: 80px;
    }
    .left-2 {
      z-index: 5;
      position: sticky;
      flex: 0 0 260px;
      left: 340px;
    }
    .sort {
      z-index: 5;
      position: sticky;
      left: 0px;
      width: 60px;
      flex: 0 0 60px;
    }
    .right {
      position: sticky;
      right: 0px;
      z-index: 5;
      border-left: 1px solid #e9e9e9;
      background-color: #fff;
    }
    .head-wrap {
      height: 45px;
      width: inherit;
      line-height: 45px;
      display: flex;
      flex-wrap: nowrap;
      position: sticky;
      top: 0;
      z-index: 6;
      .head {
        display: inline-block;
        background-color: #f7f7f7;
        text-align: center;
        width: 140px;
        flex: 0 0 140px;
        flex-wrap: nowrap;
        border-right: 1px solid #e9e9e9;
        border-top: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        align-items: center;
        justify-content: center;
        &:first-child {
          border-left: 1px solid #e9e9e9;
        }
        .ivu-icon-md-add-circle,
        .ivu-icon-md-close-circle {
          color: rgb(35, 109, 255);
          font-size: 24px;
          cursor: pointer;
        }
        .ivu-icon-md-close-circle {
          color: rgb(242, 104, 104);
        }
      }
      .tools-wrap {
        width: 300px;
        flex: 0 0 300px;
        span {
          display: flex;
          align-items: center;
        }
        display: flex;
        align-items: center;
      }
    }
    .content-wrap {
      width: 100%;
      .content-limit {
        position: relative;
        width: 100%;
        &:hover {
          .box {
            background-color: #ebf7ff !important;
          }
        }
        display: flex;
        .box {
          background-color: #fff;
          display: block;
          display: flex;
          width: 140px;
          justify-content: center;
          min-height: 50px;
          align-items: center;
          padding: 0 4px;
          height: auto;
          flex: 0 0 140px;
          border-bottom: 1px solid #e9e9e9;
          border-right: 1px solid #e9e9e9;
          &:first-child {
            border-left: 1px solid #e9e9e9;
          }
        }
        .tools-wrap {
          width: 300px;
          flex: 0 0 300px;
        }
      }
    }
  }
}
</style>
  